import StudentAppBlock from './StudentAppBlock';
import { StudentAppBlockProps, StudentAppBlockValueProps } from './types';

export type { StudentAppBlockProps, StudentAppBlockValueProps };
export default StudentAppBlock;
